import { useRef, useState } from 'react';

export const useSearchTerms = () => {
    const [searchTerms, setSearchTerms] = useState<Record<string, string>>({});
    const searchTimersRef = useRef<Record<string, number>>({});

    const handleSearch = (field: string, search: string, onSearch?: (search: string) => void) => {
        if (!onSearch) return;

        // debounce per-field to reduce API requests
        const existing = searchTimersRef.current[field];
        if (existing) {
            window.clearTimeout(existing);
        }
        const timer = window.setTimeout(() => {
            setSearchTerms(prev => ({ ...prev, [field]: search }));
        }, 400);
        searchTimersRef.current[field] = timer;
    };

    return {
        searchTerms,
        setSearchTerms,
        handleSearch,
        searchTimersRef,
    };
};
